// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"om_a bhs_a bhs_x","FilterForm__vgroup":"om_b bhs_sv"};